var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFluentBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 7.4532L20.9052 5.9916C20.7721 5.88795 20.6251 5.80352 20.4684 5.7408L13.56 2.9772C12.5586 2.57659 11.4414 2.57659 10.44 2.9772L8.25003 3.8532L17.25 7.4532ZM15.636 8.1L12 9.5532V9.552L3.09603 5.9916C3.22914 5.88792 3.37618 5.80349 3.53283 5.7408L6.63603 4.5L15.636 8.1ZM2.40003 7.4124C2.39987 7.28166 2.41395 7.15129 2.44203 7.0236L11.4 10.6056V21.2796C11.0736 21.2328 10.752 21.1464 10.44 21.0216L3.53163 18.2592C2.84809 17.9858 2.3999 17.3238 2.40003 16.5876V7.4124ZM12.6 21.2796C12.9264 21.2316 13.248 21.1476 13.56 21.0216L20.4684 18.258C21.1512 17.985 21.5992 17.3241 21.6 16.5888V7.4124C21.6 7.2804 21.5856 7.1484 21.558 7.0236L12.6 10.6056V21.2796Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentBox);
export default __webpack_public_path__ + "static/media/fluent_box.d39d9fddc1ccc347f905cf934cb0c359.svg";
export { ForwardRef as ReactComponent };